import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography } from '@material-ui/core';
import { LayerDetailsTabs } from './LayerDetailsTabs';
import { CoreLayerDetails } from './CoreLayerDetails';
import { addLayerToCalculation, editLayerInCalculation, clearInterimCalculation } from '../../actions/calculationActions';
import { customLayerDefaults, } from '../../types/store/calculationTypes';
import styles from './LayerModal.module.scss';
import { interimOrCurrentCalculationSelector, masterDataSelector } from '../../store/selectors';
import { LayerMaterialTypeKeys } from '../../types/store/LayerMaterialTypes';
import { isStringNotNullishOrWhitespace, isStringValidNumberInRangeInclusive, isStringValidPostiveNumber, } from '../../common/inputValidation';
import { uuid } from '../../common/uuid';
export var LayerModalMode;
(function (LayerModalMode) {
    LayerModalMode["ADD"] = "ADD";
    LayerModalMode["EDIT"] = "EDIT";
})(LayerModalMode || (LayerModalMode = {}));
export const defaultState = {
    masterLayer: null,
    layerThickness: null,
    shortCode: null,
    hasShortCodeError: false,
    customReferenceLayer: null,
    bridgeMaterial: null,
    bridgeWidth: '',
    bridgeCentres: '',
    bridgeNonBridgedHeight: null,
    fasteners: null,
    fastenersCrossArea: '',
    fastenersNumber: '',
    airGapsCorrectionLevelOverride: undefined,
    notes: null,
    tabIndex: false,
};
const getInitMasterDataLayer = ({ defaults, masterData, mode, interimLayer }) => {
    if (mode === LayerModalMode.ADD || !masterData.layers) {
        return defaults.masterLayer;
    }
    const masterDataLayer = masterData.layers.find(masterDataLayer => masterDataLayer.id === (interimLayer ? interimLayer.id : ''));
    return masterDataLayer || defaults.masterLayer;
};
const getInitLayerThickness = ({ mode, interimLayer, defaults }) => mode === LayerModalMode.EDIT ? (interimLayer ? interimLayer.thicknessMillimetres : defaults.layerThickness) : defaults.layerThickness;
const getInitShortCode = ({ interimLayer }) => '';
const getInitHasShortCodeError = ({ defaults }) => defaults.hasShortCodeError;
const getInitCustomReferenceLayer = ({ defaults, mode, interimLayer }) => {
    if (mode === LayerModalMode.ADD || !(interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.customReferenceLayer)) {
        return defaults.customReferenceLayer;
    }
    return (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.customReferenceLayer) || defaults.customReferenceLayer;
};
const getInitMasterDataBridgeMaterial = ({ defaults, masterData, mode, interimLayer, }) => {
    var _a;
    if (mode === LayerModalMode.ADD || !masterData.bridgeMaterials || !(interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging)) {
        return defaults.bridgeMaterial;
    }
    let material;
    if (((_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _a === void 0 ? void 0 : _a.id) === -1) {
        material = {
            id: interimLayer.layerBridging.id,
            name: interimLayer.layerBridging.name,
            bridgeDescription: interimLayer.layerBridging.bridgeDescription,
            bridgeThermalConductivity: interimLayer.layerBridging.bridgeThermalConductivity,
            defaultBridgeWidth: interimLayer.layerBridging.bridgeWidthMillimetres,
            defaultCentresDistance: interimLayer.layerBridging.centresDistanceMillimetres,
            defaultNonBridgeHeight: interimLayer.layerBridging.nonBridgeHeightMillimetres,
        };
    }
    else {
        material = masterData.bridgeMaterials.find(masterMaterial => { var _a, _b; return masterMaterial.id === ((_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''); });
    }
    return material || defaults.bridgeMaterial;
};
const getInitBridgeWidth = ({ defaults, mode, interimLayer }) => { var _a, _b; return mode === LayerModalMode.EDIT ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _a === void 0 ? void 0 : _a.bridgeWidthMillimetres) !== null && _b !== void 0 ? _b : defaults.bridgeWidth : defaults.bridgeWidth; };
const getInitBridgeCentres = ({ defaults, mode, interimLayer }) => { var _a, _b; return mode === LayerModalMode.EDIT ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _a === void 0 ? void 0 : _a.centresDistanceMillimetres) !== null && _b !== void 0 ? _b : defaults.bridgeCentres : defaults.bridgeCentres; };
const getInitBridgeNonBridgedHeight = ({ defaults, mode, interimLayer }) => {
    var _a, _b;
    return mode === LayerModalMode.EDIT
        ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _a === void 0 ? void 0 : _a.nonBridgeHeightMillimetres) !== null && _b !== void 0 ? _b : defaults.bridgeNonBridgedHeight
        : defaults.bridgeNonBridgedHeight;
};
const getInitMasterDataMechanicalFastener = ({ defaults, masterData, mode, interimLayer, }) => {
    if (mode === LayerModalMode.ADD || !masterData.mechanicalFasteners || !(interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener)) {
        return defaults.fasteners;
    }
    const fasteners = masterData.mechanicalFasteners.find(fastener => { var _a, _b; return fastener.id === ((_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''); });
    return fasteners || defaults.fasteners;
};
const getInitFastenersCrossArea = ({ defaults, mode, interimLayer }) => {
    var _a, _b;
    return mode === LayerModalMode.EDIT
        ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _a === void 0 ? void 0 : _a.crossSectionalAreaMillimetresSquared) !== null && _b !== void 0 ? _b : defaults.fastenersCrossArea
        : defaults.fastenersCrossArea;
};
const getInitFastenersNumber = ({ defaults, mode, interimLayer }) => {
    var _a, _b;
    return mode === LayerModalMode.EDIT
        ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _a === void 0 ? void 0 : _a.fasteningsPerMetreSquared) !== null && _b !== void 0 ? _b : defaults.fastenersNumber
        : defaults.fastenersNumber;
};
const getInitAirGapsCorrectionLevelOverride = ({ defaults, interimLayer }) => { var _a, _b; return (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.airGapsCorrection) === null || _a === void 0 ? void 0 : _a.overrideCorrectionFactor) !== null && _b !== void 0 ? _b : defaults.airGapsCorrectionLevelOverride; };
const getInitTabIndex = ({ initialTabIndex }) => initialTabIndex;
const getInitVapourResistance = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.vapourResistance) || null;
const getInitVapourResistivity = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.vapourResistivity) || null;
const getInitPrimaryGroup = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.primaryGroup) || null;
const getInitSecondaryGroup = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.secondaryGroup) || null;
const getInitSector = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.sector) || null;
const getInitApplication = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.application) || null;
const getInitBudgetCategory = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.budgetCategory) || null;
const getInitProductTechnology = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.productTechnology) || null;
const getInitProductBrand = ({ interimLayer }) => (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.productBrand) || null;
const getInitNotes = ({ defaults, mode, interimLayer }) => { var _a, _b; return mode === LayerModalMode.EDIT ? (_b = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerNotes) === null || _a === void 0 ? void 0 : _a.notes) !== null && _b !== void 0 ? _b : defaults.notes : defaults.notes; };
export function stateInitializer(args) {
    return {
        masterLayer: getInitMasterDataLayer(args),
        layerThickness: getInitLayerThickness(args),
        shortCode: getInitShortCode(args),
        hasShortCodeError: getInitHasShortCodeError(args),
        notes: getInitNotes(args),
        customReferenceLayer: getInitCustomReferenceLayer(args),
        bridgeMaterial: getInitMasterDataBridgeMaterial(args),
        bridgeWidth: getInitBridgeWidth(args),
        bridgeCentres: getInitBridgeCentres(args),
        bridgeNonBridgedHeight: getInitBridgeNonBridgedHeight(args),
        fasteners: getInitMasterDataMechanicalFastener(args),
        fastenersCrossArea: getInitFastenersCrossArea(args),
        fastenersNumber: getInitFastenersNumber(args),
        airGapsCorrectionLevelOverride: getInitAirGapsCorrectionLevelOverride(args),
        tabIndex: getInitTabIndex(args),
        vapourResistance: getInitVapourResistance(args),
        vapourResistivity: getInitVapourResistivity(args),
        primaryGroup: getInitPrimaryGroup(args),
        secondaryGroup: getInitSecondaryGroup(args),
        sector: getInitSector(args),
        application: getInitApplication(args),
        budgetCategory: getInitBudgetCategory(args),
        productTechnology: getInitProductTechnology(args),
        productBrand: getInitProductBrand(args),
    };
}
const getVapourResistance = (masterLayer, layerThickness) => {
    var _a;
    if (!masterLayer) {
        return null;
    }
    if (masterLayer.vapourResistance) {
        return masterLayer.vapourResistance;
    }
    const variableResistances = [
        { vapourResistance: Number(masterLayer.vr4), vapourResistanceBreak: Number(masterLayer.vrBreak3) },
        { vapourResistance: Number(masterLayer.vr3), vapourResistanceBreak: Number(masterLayer.vrBreak2) },
        { vapourResistance: Number(masterLayer.vr2), vapourResistanceBreak: Number(masterLayer.vrBreak1) },
        { vapourResistance: Number(masterLayer.vr1), vapourResistanceBreak: 0 },
    ];
    return ((_a = variableResistances.find(vvr => Number(layerThickness) > vvr.vapourResistanceBreak)) === null || _a === void 0 ? void 0 : _a.vapourResistance.toString()) || null;
};
const getSetMasterLayer = (setLocalState) => (defaults) => (masterLayer, apiBridgeResponse) => {
    const bridgeMaterial = masterLayer.bridgeMaterial;
    if (bridgeMaterial) {
        setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeMaterial, bridgeWidth: bridgeMaterial.defaultBridgeWidth, bridgeCentres: bridgeMaterial.defaultCentresDistance, bridgeNonBridgedHeight: bridgeMaterial.defaultNonBridgeHeight, tabIndex: bridgingTabIndex })));
    }
    else if ((apiBridgeResponse === null || apiBridgeResponse === void 0 ? void 0 : apiBridgeResponse.id) === -1) {
        getResetBridgingDetails(setLocalState)(defaults);
    }
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { masterLayer, layerThickness: masterLayer.defaultThickness, customReferenceLayer: masterLayer != null ? defaults.customReferenceLayer : prevState.customReferenceLayer, airGapsCorrectionLevelOverride: !(masterLayer.layerMaterialType === LayerMaterialTypeKeys.GenericInsulation)
            ? defaults.airGapsCorrectionLevelOverride
            : prevState.airGapsCorrectionLevelOverride, vapourResistance: getVapourResistance(masterLayer, masterLayer.defaultThickness), vapourResistivity: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.vapourResistivity) || null, primaryGroup: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.primaryGroup) || null, secondaryGroup: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.secondaryGroup) || null, sector: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.sector) || null, application: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.application) || null, budgetCategory: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.budgetCategory) || null, productTechnology: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.productTechnology) || null, productBrand: (masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.productBrand) || null })));
};
const getSetLayerThickness = (setLocalState) => (layerThickness) => {
    setLocalState((prevState) => (Object.assign(Object.assign({}, prevState), { layerThickness, vapourResistance: getVapourResistance(prevState.masterLayer, layerThickness) })));
};
const getSetShortCode = (setLocalState) => (shortCode) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { shortCode })));
};
const getSetHasShortCodeError = (setLocalState) => (hasShortCodeError) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { hasShortCodeError })));
};
const getSetCustomReferenceLayer = (setLocalState) => (defaults) => (customReferenceLayer) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { masterLayer: customReferenceLayer != null ? defaults.masterLayer : prevState.masterLayer, 
        // Only clear the layer thickness if we are chaging customReferenceLayer from null to a value
        layerThickness: prevState.customReferenceLayer != null ? prevState.layerThickness : defaults.layerThickness, airGapsCorrectionLevelOverride: customReferenceLayer == null || !(customReferenceLayer.layerMaterialType === LayerMaterialTypeKeys.GenericInsulation)
            ? defaults.airGapsCorrectionLevelOverride
            : prevState.airGapsCorrectionLevelOverride, customReferenceLayer })));
};
const getUpdateCustomReferenceLayer = (setLocalState) => (defaults) => (customReferenceLayer) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { masterLayer: defaults.masterLayer, airGapsCorrectionLevelOverride: customReferenceLayer == null || !(customReferenceLayer.layerMaterialType === LayerMaterialTypeKeys.GenericInsulation)
            ? defaults.airGapsCorrectionLevelOverride
            : prevState.airGapsCorrectionLevelOverride, customReferenceLayer: prevState.customReferenceLayer == null
            ? Object.assign(Object.assign({}, customLayerDefaults), customReferenceLayer) : Object.assign(Object.assign({}, prevState.customReferenceLayer), customReferenceLayer) })));
};
const getSetBridgeMaterial = (setLocalState) => (bridgeMaterial) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeMaterial, bridgeWidth: bridgeMaterial.defaultBridgeWidth, bridgeCentres: bridgeMaterial.defaultCentresDistance, bridgeNonBridgedHeight: bridgeMaterial.defaultNonBridgeHeight })));
};
const getSetBridgeWidth = (setLocalState) => (bridgeWidth) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeWidth })));
};
const getSetBridgeCentres = (setLocalState) => (bridgeCentres) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeCentres })));
};
const getSetBridgeNonBridgedHeight = (setLocalState) => (bridgeNonBridgedHeight) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeNonBridgedHeight })));
};
const getSetFasteners = (setLocalState) => (fasteners) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { fasteners, fastenersCrossArea: fasteners.defaultCrossArea, fastenersNumber: fasteners.defaultNumber })));
};
const getSetFastenersCrossArea = (setLocalState) => (fastenersCrossArea) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { fastenersCrossArea })));
};
const getSetFastenersNumber = (setLocalState) => (fastenersNumber) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { fastenersNumber })));
};
const getSetAirGapsCorrectionLevelOverride = (setLocalState) => (airGapsCorrectionLevelOverride) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { airGapsCorrectionLevelOverride })));
};
const getSetNotes = (setLocalState) => (notes) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { notes })));
};
const getResetCoreDetails = (setLocalState) => (defaults) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { masterLayer: defaults.masterLayer, layerThickness: defaults.layerThickness, shortCode: defaults.shortCode, airGapsCorrectionLevelOverride: defaults.airGapsCorrectionLevelOverride, customReferenceLayer: defaults.customReferenceLayer, notes: defaults.notes })));
};
const getResetBridgingDetails = (setLocalState) => (defaults) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { bridgeMaterial: defaults.bridgeMaterial, bridgeWidth: defaults.bridgeWidth, bridgeCentres: defaults.bridgeCentres, bridgeNonBridgedHeight: defaults.bridgeNonBridgedHeight })));
};
const getResetFastenerDetails = (setLocalState) => (defaults) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { fasteners: defaults.fasteners, fastenersCrossArea: defaults.fastenersCrossArea, fastenersNumber: defaults.fastenersNumber })));
};
const getResetAllDetails = (setLocalState) => (defaults) => {
    getResetCoreDetails(setLocalState)(defaults);
    getResetBridgingDetails(setLocalState)(defaults);
    getResetFastenerDetails(setLocalState)(defaults);
};
const getSetTabIndex = (setLocalState) => (tabIndex) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { tabIndex })));
};
const getSetVapourResistances = (setLocalState) => (vapourResistance, vapourResistivity) => {
    setLocalState(prevState => (Object.assign(Object.assign({}, prevState), { vapourResistance,
        vapourResistivity })));
};
export function getSetters(setLocalState, defaults) {
    return {
        setMasterLayer: getSetMasterLayer(setLocalState)(defaults),
        setLayerThickness: getSetLayerThickness(setLocalState),
        setShortCode: getSetShortCode(setLocalState),
        setHasShortCodeError: getSetHasShortCodeError(setLocalState),
        setLayerNotes: getSetNotes(setLocalState),
        setCustomReferenceLayer: getSetCustomReferenceLayer(setLocalState)(defaults),
        updateCustomReferenceLayer: getUpdateCustomReferenceLayer(setLocalState)(defaults),
        setBridgeMaterial: getSetBridgeMaterial(setLocalState),
        setBridgeWidth: getSetBridgeWidth(setLocalState),
        setBridgeCentres: getSetBridgeCentres(setLocalState),
        setBridgeNonBridgedHeight: getSetBridgeNonBridgedHeight(setLocalState),
        setFasteners: getSetFasteners(setLocalState),
        setFastenersCrossArea: getSetFastenersCrossArea(setLocalState),
        setFastenersNumber: getSetFastenersNumber(setLocalState),
        setAirGapsCorrectionLevelOverride: getSetAirGapsCorrectionLevelOverride(setLocalState),
        resetCoreDetails: getResetCoreDetails(setLocalState),
        resetBridgingDetails: getResetBridgingDetails(setLocalState),
        resetFastenerDetails: getResetFastenerDetails(setLocalState),
        resetAllDetails: getResetAllDetails(setLocalState),
        setTabIndex: getSetTabIndex(setLocalState),
        setVapourResistances: getSetVapourResistances(setLocalState),
    };
}
// The logic in this function must reflect the buisiness logic in the `Kics.Technical.Calculation` project, `LayerCalculator.cs::CalculateBridgingPercentage`
function isBridgingPercentageInvalid(bridgeWidth, bridgeCentres, nonBridgeHeight) {
    const decimalPlaces = 1;
    const precision = decimalPlaces * 10;
    const width = Math.round(+bridgeWidth * precision) / precision;
    const centres = Math.round(+bridgeCentres * precision) / precision;
    if (nonBridgeHeight == null || nonBridgeHeight === '') {
        if (width < centres) {
            return false;
        }
    }
    else {
        // 2 Dimensional
        const height = Math.round(+nonBridgeHeight * precision) / precision;
        const percentage = 1 - ((centres - width) * height) / (centres * (height + width));
        if (percentage > 0 && percentage < 1) {
            return false;
        }
    }
    return true;
}
function isModalStateInvalid(state) {
    const { masterLayer, layerThickness, customReferenceLayer, bridgeMaterial, bridgeWidth, bridgeCentres, bridgeNonBridgedHeight, fasteners, fastenersCrossArea, fastenersNumber, } = state;
    const isThereAValidReferenceLayerSelected = masterLayer != null || customReferenceLayer != null;
    const isLayerThicknessValid = (customReferenceLayer === null || customReferenceLayer === void 0 ? void 0 : customReferenceLayer.isBlank) || isStringValidPostiveNumber(layerThickness);
    const isACustomReferenceLayerSelectedAndTheCustomValuesAreValid = !customReferenceLayer ||
        (isStringNotNullishOrWhitespace(customReferenceLayer.name) &&
            ((customReferenceLayer === null || customReferenceLayer === void 0 ? void 0 : customReferenceLayer.isBlank) ||
                (isStringValidPostiveNumber(customReferenceLayer.thermalConductivity) &&
                    !isStringNotNullishOrWhitespace(customReferenceLayer.thermalResistance)) ||
                (isStringValidPostiveNumber(customReferenceLayer.thermalResistance) &&
                    !isStringNotNullishOrWhitespace(customReferenceLayer.thermalConductivity))) &&
            ((customReferenceLayer === null || customReferenceLayer === void 0 ? void 0 : customReferenceLayer.isBlank) || isStringValidNumberInRangeInclusive(0, 1, customReferenceLayer.insideEmissivity)) &&
            ((customReferenceLayer === null || customReferenceLayer === void 0 ? void 0 : customReferenceLayer.isBlank) || isStringValidNumberInRangeInclusive(0, 1, customReferenceLayer.outsideEmissivity)));
    const areAllBridgingFieldsEmpty = [bridgeMaterial, bridgeWidth, bridgeCentres, bridgeNonBridgedHeight].every(property => !property);
    const doesBridgingHaveEmptyRequiredField = [bridgeMaterial, bridgeWidth, bridgeCentres].some(property => !property);
    const areAllBridgingFieldsValid = [bridgeWidth, bridgeCentres, bridgeNonBridgedHeight].every(property => !property || Number(property) > 0);
    const areAllFastenerFieldsEmpty = [fasteners, fastenersCrossArea, fastenersNumber].every(property => !property);
    const doesFastenerHaveEmptyRequiredField = [fasteners, fastenersCrossArea, fastenersNumber].some(property => !property);
    const areAllFastenerFieldsValid = [fastenersCrossArea, fastenersNumber].every(property => !property || Number(property) > 0);
    return (!isThereAValidReferenceLayerSelected ||
        !isLayerThicknessValid ||
        !isACustomReferenceLayerSelectedAndTheCustomValuesAreValid ||
        (!areAllFastenerFieldsEmpty && (doesFastenerHaveEmptyRequiredField || !areAllFastenerFieldsValid)) ||
        (!areAllBridgingFieldsEmpty &&
            (doesBridgingHaveEmptyRequiredField ||
                !areAllBridgingFieldsValid ||
                isBridgingPercentageInvalid(bridgeWidth, bridgeCentres, bridgeNonBridgedHeight))));
}
export const closedTabIndex = false;
export const bridgingTabIndex = 0;
export const fastenersTabIndex = 1;
export const airGapsTabIndex = 2;
export const vapourTabIndex = 3;
export const layerNotesTabIndex = 4;
function LayerModalWithDefaults(defaults, props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { layerInstanceId, mode, onClose, setLayerInstanceId, initialTabIndex } = props;
    const dispatch = useDispatch();
    const masterData = useSelector(masterDataSelector);
    const calculation = useSelector(interimOrCurrentCalculationSelector);
    const refShortCodeField = React.createRef();
    const refThicknessField = React.createRef();
    const interimLayer = calculation
        ? calculation.layers.find((layer) => layer.instanceId === layerInstanceId) || null
        : null;
    const initializerArgs = { defaults, masterData, interimLayer, mode, initialTabIndex };
    function initState() {
        return stateInitializer(initializerArgs);
    }
    const [localState, setLocalState] = React.useState(initState);
    const { masterLayer, notes, layerThickness, shortCode, hasShortCodeError, customReferenceLayer, bridgeMaterial, bridgeWidth, bridgeCentres, bridgeNonBridgedHeight, fasteners, fastenersCrossArea, fastenersNumber, airGapsCorrectionLevelOverride, tabIndex, vapourResistance, vapourResistivity, primaryGroup, secondaryGroup, sector, application, budgetCategory, productTechnology, productBrand, } = localState;
    const { setMasterLayer, setLayerThickness, setShortCode, setHasShortCodeError, setLayerNotes, setCustomReferenceLayer, updateCustomReferenceLayer, setBridgeMaterial, setBridgeWidth, setBridgeCentres, setBridgeNonBridgedHeight, setFasteners, setFastenersCrossArea, setFastenersNumber, setAirGapsCorrectionLevelOverride, resetBridgingDetails, resetFastenerDetails, resetAllDetails, setTabIndex, setVapourResistances, } = getSetters(setLocalState, defaults);
    const clearBridgingDetails = () => resetBridgingDetails(defaults);
    const clearFastenersDetails = () => resetFastenerDetails(defaults);
    const clearAllDetails = React.useCallback(() => {
        resetAllDetails(defaults);
    }, [resetAllDetails, defaults]);
    const focusOnShortCodeField = React.useCallback(() => {
        var _a;
        if (refShortCodeField.current) {
            (_a = refShortCodeField === null || refShortCodeField === void 0 ? void 0 : refShortCodeField.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input')[0].focus();
        }
    }, [refShortCodeField]);
    const selectAllTextInShortCodeField = React.useCallback(() => {
        var _a;
        if (refShortCodeField.current) {
            (_a = refShortCodeField === null || refShortCodeField === void 0 ? void 0 : refShortCodeField.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input')[0].select();
        }
    }, [refShortCodeField]);
    const focusOnThicknessField = React.useCallback(() => {
        if (refThicknessField.current) {
            refThicknessField.current.getElementsByTagName('input')[0].select();
        }
    }, [refThicknessField]);
    const calculatedCorrectionFactor = (_a = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.airGapsCorrection) === null || _a === void 0 ? void 0 : _a.calculatedCorrectionFactor;
    React.useEffect(() => {
        if (isModalStateInvalid(localState)) {
            return;
        }
        const customReferenceLayerRequest = customReferenceLayer != null
            ? Object.assign({}, customReferenceLayer) : undefined;
        const layerBridging = bridgeMaterial != null
            ? {
                id: bridgeMaterial.id,
                bridgeWidthMillimetres: bridgeWidth,
                centresDistanceMillimetres: bridgeCentres,
                nonBridgeHeightMillimetres: bridgeNonBridgedHeight,
            }
            : undefined;
        const mechanicalFasteners = fasteners != null
            ? {
                id: fasteners.id,
                crossSectionalAreaMillimetresSquared: fastenersCrossArea,
                fasteningsPerMetreSquared: fastenersNumber,
            }
            : undefined;
        const layerNotes = isStringNotNullishOrWhitespace(notes) && notes != null
            ? {
                notes,
            }
            : undefined;
        if (mode === LayerModalMode.EDIT && layerInstanceId) {
            dispatch(editLayerInCalculation(layerInstanceId, masterLayer, layerThickness, customReferenceLayerRequest, layerBridging, mechanicalFasteners, calculatedCorrectionFactor, airGapsCorrectionLevelOverride, layerNotes, vapourResistance, vapourResistivity, primaryGroup, secondaryGroup, sector, application, budgetCategory, productTechnology, productBrand, true));
        }
        else if (mode === LayerModalMode.ADD && layerInstanceId) {
            dispatch(addLayerToCalculation(layerInstanceId, masterLayer, layerThickness, customReferenceLayerRequest, layerBridging, mechanicalFasteners, calculatedCorrectionFactor, airGapsCorrectionLevelOverride, layerNotes, vapourResistance, vapourResistivity, primaryGroup, secondaryGroup, sector, application, budgetCategory, productTechnology, productBrand, true));
        }
    }, [
        dispatch,
        mode,
        layerInstanceId,
        notes,
        localState,
        masterLayer,
        layerThickness,
        customReferenceLayer,
        bridgeMaterial,
        bridgeWidth,
        bridgeCentres,
        bridgeNonBridgedHeight,
        fasteners,
        fastenersCrossArea,
        fastenersNumber,
        calculatedCorrectionFactor,
        airGapsCorrectionLevelOverride,
        vapourResistance,
        vapourResistivity,
        primaryGroup,
        secondaryGroup,
        sector,
        application,
        budgetCategory,
        productTechnology,
        productBrand,
    ]);
    const handleSubmitLayer = React.useCallback((event) => {
        event.preventDefault();
        if (isModalStateInvalid(localState)) {
            return;
        }
        const customReferenceLayerRequest = customReferenceLayer != null
            ? Object.assign({}, customReferenceLayer) : undefined;
        const layerBridging = bridgeMaterial != null
            ? {
                id: bridgeMaterial.id,
                bridgeWidthMillimetres: bridgeWidth,
                centresDistanceMillimetres: bridgeCentres,
                nonBridgeHeightMillimetres: bridgeNonBridgedHeight,
            }
            : undefined;
        const mechanicalFasteners = fasteners != null
            ? {
                id: fasteners.id,
                crossSectionalAreaMillimetresSquared: fastenersCrossArea,
                fasteningsPerMetreSquared: fastenersNumber,
            }
            : undefined;
        const layerNotes = isStringNotNullishOrWhitespace(notes) && notes != null
            ? {
                notes,
            }
            : undefined;
        if (mode === LayerModalMode.EDIT && layerInstanceId) {
            dispatch(editLayerInCalculation(layerInstanceId, masterLayer, layerThickness, customReferenceLayerRequest, layerBridging, mechanicalFasteners, calculatedCorrectionFactor, airGapsCorrectionLevelOverride, layerNotes, vapourResistance, vapourResistivity, primaryGroup !== null && primaryGroup !== void 0 ? primaryGroup : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.primaryGroup, secondaryGroup !== null && secondaryGroup !== void 0 ? secondaryGroup : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.secondaryGroup, sector !== null && sector !== void 0 ? sector : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.sector, application !== null && application !== void 0 ? application : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.application, budgetCategory !== null && budgetCategory !== void 0 ? budgetCategory : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.budgetCategory, productTechnology !== null && productTechnology !== void 0 ? productTechnology : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.productTechnology, productBrand !== null && productBrand !== void 0 ? productBrand : masterLayer === null || masterLayer === void 0 ? void 0 : masterLayer.productBrand));
            onClose();
        }
        else if (mode === LayerModalMode.ADD && layerInstanceId) {
            dispatch(addLayerToCalculation(layerInstanceId, masterLayer, layerThickness, customReferenceLayerRequest, layerBridging, mechanicalFasteners, calculatedCorrectionFactor, airGapsCorrectionLevelOverride, layerNotes, vapourResistance, vapourResistivity, primaryGroup, secondaryGroup, sector, application, budgetCategory, productTechnology, productBrand));
            clearAllDetails();
            setTabIndex(false);
            setLayerInstanceId(uuid());
            focusOnShortCodeField();
        }
    }, [
        dispatch,
        mode,
        localState,
        notes,
        layerInstanceId,
        onClose,
        masterLayer,
        layerThickness,
        customReferenceLayer,
        bridgeMaterial,
        bridgeWidth,
        bridgeCentres,
        bridgeNonBridgedHeight,
        fasteners,
        fastenersCrossArea,
        fastenersNumber,
        calculatedCorrectionFactor,
        airGapsCorrectionLevelOverride,
        clearAllDetails,
        setTabIndex,
        focusOnShortCodeField,
        setLayerInstanceId,
        vapourResistance,
        vapourResistivity,
        primaryGroup,
        secondaryGroup,
        sector,
        application,
        budgetCategory,
        productTechnology,
        productBrand,
    ]);
    const handleDialogCancel = () => {
        dispatch(clearInterimCalculation());
        onClose();
    };
    const setLayerFromShortCode = React.useCallback((shortCode, apiBridgeResponse) => {
        const layer = masterData.layers.find(layer => layer.shortCode.toLowerCase() === shortCode.toLowerCase());
        if (shortCode && layer) {
            setHasShortCodeError(false);
            setMasterLayer(layer, apiBridgeResponse);
            setShortCode(defaults.shortCode || '');
            focusOnThicknessField();
        }
        else {
            setHasShortCodeError(true);
            selectAllTextInShortCodeField();
        }
    }, [
        masterData.layers,
        setMasterLayer,
        setShortCode,
        focusOnThicknessField,
        defaults.shortCode,
        setHasShortCodeError,
        selectAllTextInShortCodeField,
    ]);
    return (React.createElement(Dialog, { open: true, onClose: handleDialogCancel, onEntered: () => {
            if (mode === LayerModalMode.ADD) {
                focusOnShortCodeField();
            }
            else if (mode === LayerModalMode.EDIT) {
                focusOnThicknessField();
            }
        }, "aria-labelledby": "modal-layer-title" },
        React.createElement("form", { "data-qa-id": "layerModalForm", onSubmit: handleSubmitLayer, noValidate: true },
            React.createElement("div", { className: styles.modalHeader },
                React.createElement(DialogTitle, { id: "modal-layer-title" },
                    React.createElement(Typography, { component: "span", variant: "h5" }, mode === LayerModalMode.EDIT ? 'Edit Layer' : 'Add Layer'))),
            React.createElement("div", { className: styles.modalContent },
                React.createElement(DialogContent, null,
                    React.createElement(CoreLayerDetails, { masterData: masterData, clearAllDetails: clearAllDetails, layerThermalResistance: interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.thermalResistance, apiBridgeResponse: interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging, masterLayer: masterLayer, setMasterLayer: setMasterLayer, layerThickness: layerThickness, setLayerThickness: setLayerThickness, shortCode: shortCode, setShortCode: setShortCode, hasShortCodeError: hasShortCodeError, setHasShortCodeError: setHasShortCodeError, setLayerFromShortCode: setLayerFromShortCode, customReferenceLayer: customReferenceLayer, setCustomReferenceLayer: setCustomReferenceLayer, updateCustomReferenceLayer: updateCustomReferenceLayer, refShortCodeField: refShortCodeField, refThicknessField: refThicknessField, isLocked: calculation === null || calculation === void 0 ? void 0 : calculation.locked }),
                    !(customReferenceLayer === null || customReferenceLayer === void 0 ? void 0 : customReferenceLayer.isBlank) && (React.createElement(LayerDetailsTabs, { tabIndex: tabIndex, setTabIndex: setTabIndex, mode: mode, masterData: masterData, referenceLayer: masterLayer !== null && masterLayer !== void 0 ? masterLayer : customReferenceLayer, bridgeMaterial: bridgeMaterial, setBridgeMaterial: setBridgeMaterial, bridgeWidth: bridgeWidth, setBridgeWidth: setBridgeWidth, bridgeCentres: bridgeCentres, setBridgeCentres: setBridgeCentres, bridgeNonBridgedHeight: bridgeNonBridgedHeight, setBridgeNonBridgedHeight: setBridgeNonBridgedHeight, layerBridgePercentage: (_b = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.layerBridging) === null || _b === void 0 ? void 0 : _b.bridgePercentage, clearBridgingDetails: clearBridgingDetails, fasteners: fasteners, setFasteners: setFasteners, fastenersCrossArea: fastenersCrossArea, setFastenersCrossArea: setFastenersCrossArea, fastenersNumber: fastenersNumber, setFastenersNumber: setFastenersNumber, clearFastenersDetails: clearFastenersDetails, fastenersAlpha: (_c = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _c === void 0 ? void 0 : _c.alphaCoefficient, fastenersThermalConductivity: (_d = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _d === void 0 ? void 0 : _d.thermalConductivity, fastenersCorrectionFactor: (_e = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.mechanicalFastener) === null || _e === void 0 ? void 0 : _e.correctionFactor, airGapsCorrectionLevel: (_f = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.airGapsCorrection) === null || _f === void 0 ? void 0 : _f.correctionFactorResult, airGapsCorrectionLevelOverride: airGapsCorrectionLevelOverride, setAirGapsCorrectionLevelOverride: setAirGapsCorrectionLevelOverride, insideEmissivity: interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.insideEmissivity, outsideEmissivity: interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.outsideEmissivity, airGapsCorrectionResultValue: (_g = interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.airGapsCorrection) === null || _g === void 0 ? void 0 : _g.airGapsCorrectionResultValue, totalAirGapsCorrectionFactor: calculation === null || calculation === void 0 ? void 0 : calculation.airGapsCorrectionFactor, setVapourResistances: setVapourResistances, vapourResistance: (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.vapourResistance) || null, vapourResistivity: (interimLayer === null || interimLayer === void 0 ? void 0 : interimLayer.vapourResistivity) || null, notes: notes, setLayerNotes: setLayerNotes, isLocked: calculation === null || calculation === void 0 ? void 0 : calculation.locked })))),
            React.createElement("div", { className: styles.modalActions },
                React.createElement(DialogActions, null,
                    React.createElement(Grid, { container: true, spacing: 2, justify: "flex-end" },
                        React.createElement(Grid, { container: true, item: true, xs: 2, justify: "flex-end" },
                            React.createElement(Button, { "data-qa-id": "layerCloseButton", onClick: handleDialogCancel, variant: "outlined" }, "Cancel")),
                        React.createElement(Grid, { item: true, xs: 2 },
                            React.createElement(Button, { type: "submit", "data-qa-id": "layerSubmitButton", fullWidth: true, disabled: (calculation === null || calculation === void 0 ? void 0 : calculation.locked) || isModalStateInvalid(localState), onClick: handleSubmitLayer, color: "primary", variant: "contained" }, mode === LayerModalMode.EDIT ? 'Save' : 'Add'))))))));
}
export function getLayerModelComponent(defaults) {
    return function LayerModal(props) {
        return LayerModalWithDefaults(defaults, props);
    };
}
export const LayerModal = getLayerModelComponent(defaultState);
